import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.0019 2.5L5.00195 2.50002C3.62124 2.50002 2.50195 3.61931 2.50195 5.00002V13.3631C2.50195 14.7439 3.62124 15.8631 5.00195 15.8631H7.20997L9.46306 17.7518C9.77135 18.0102 10.2203 18.0115 10.53 17.7549L12.8134 15.8631L15.002 15.8631C16.3827 15.8631 17.502 14.7438 17.502 13.3631V5C17.502 3.61929 16.3827 2.5 15.0019 2.5ZM10.0001 6.25C10.4604 6.25 10.8335 6.6231 10.8335 7.08333V8.75C10.8335 9.21024 10.4604 9.58333 10.0001 9.58333C9.53988 9.58333 9.16679 9.21024 9.16679 8.75V7.08333C9.16679 6.6231 9.53988 6.25 10.0001 6.25ZM10.0001 10.2083C9.42483 10.2083 8.95846 10.6747 8.95846 11.25C8.95846 11.8253 9.42483 12.2917 10.0001 12.2917C10.5754 12.2917 11.0418 11.8253 11.0418 11.25C11.0418 10.6747 10.5754 10.2083 10.0001 10.2083Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }